import React, { useEffect, useState } from "react";
import { IoMdCheckmark } from "react-icons/io";
import medicine from "../../assets/icons/medicine.webp";
import PopUp from "../PopUp";
import { compareDatesIgnoringTime } from "../../utils/timeFuncs";
import {
  registerBlockSDate,
  updateSuppliesByRB,
} from "../../services/blockRegister";
import { MdClear } from "react-icons/md";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../ui-elements/Notification";
import { FaRegCheckCircle } from "react-icons/fa";
import { LuDot } from "react-icons/lu";

const suppliesUnits = {
  1: "mg",
  2: "g",
  3: "µg",
  4: "mL",
  5: "cc",
  6: "UI",
  7: "%",
  8: "mEq",
  9: "ppt",
};

const Card = ({
  sDateInfo,
  currentDate,
  pos,
  updateParentObj,
  supplies,
  updateParentSupplies,
  seasonNumber,
}) => {
  //props de un intervalo

  const [showHover, setShowHover] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [validDate, setValidDate] = useState(false);
  const [hasInvalidConsumption, setHasInvalidConsumption] = useState(false);

  useEffect(() => {
    let result = compareDatesIgnoringTime(currentDate, sDateInfo.date);
    setValidDate(result);
  }, [currentDate]);

  useEffect(() => {
    // Verificar consumos inválidos
    const invalidConsumption = sDateInfo.comsumptions.some((consumption) => {
      const matchingSupply = supplies.find(
        (supply) => supply.id === consumption.supplie.id
      );
      return matchingSupply && consumption.quantity > matchingSupply.quantity;
    });
    setHasInvalidConsumption(invalidConsumption);
  }, [sDateInfo, supplies]);

  const handleClickRegister = () => {
    const updateRegisterStatus = async () => {
      try {
        setUpdating(true);
        //hacer custom endpoint para restar cantidades de medicinas
        const response = await updateSuppliesByRB(sDateInfo.comsumptions);
        if (response?.warning) {
          Notification({
            title: "Operación inválida",
            text: `${response.warning}`,
            type: "Error",
          });
          updateParentSupplies(response.affectedSupplies); //setear el objeto actualizado en el padre
          setUpdating(false);
          throw new Error("Error al actualizar medicinas");
        } else {
          updateParentSupplies(response.updatedSupplies);
          const response2 = await registerBlockSDate(sDateInfo.id);
          IS_LOCAL_ENV && console.log("response: ", response2);
          updateParentObj(response2.doc); //setear el objeto actualizado en el padre
          setUpdating(false);
          Notification({
            title: "Operación completada",
            text: `${response.message}`,
            type: "Success",
          });
        }
      } catch (err) {
        setUpdating(false);
        IS_LOCAL_ENV && console.error(err);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
      }
    };
    updateRegisterStatus();
  };

  return (
    <div className="flex flex-col p-4 gap-y-1 items-center justify-center border-[1px] rounded-xl border-accent-green shadow-md max-w-[500px] w-full m-2">
      <div className="w-full flex items-center justify-center p-4">
        <img className="w-[90px]" src={medicine} />
      </div>
      <h1 className="font-poppins font-bold text-lg text-dark-blue pb-2">
        Intervalo: {sDateInfo.block.interval} días
      </h1>
      <div className="px-6 py-4 bg-light-purple rounded-full">
        <h2 className="text-dark-purple font-bold font-poppins ">
          {pos > 0 ? "Próxima fecha: " : "Fecha: "}
          {new Date(sDateInfo.date).toLocaleDateString("es-ES", {
            day: "numeric",
            month: "long",
            timeZone: "America/Lima",
          })}
        </h2>
      </div>
      <div className="flex flex-col items-center py-2 pt-2 gap-y-2">
        <span className="font-poppins px-2 text-default-gray font-bold">
          <a
            href="/home/listaMedicina"
            className="underline hover:text-blue-500 hover:cursor-pointer"
          >
            Medicinas
          </a>{" "}
          y{" "}
          <a
            href={`/home/temporadas/${seasonNumber}/programa`}
            className="underline hover:text-blue-500 hover:cursor-pointer"
          >
            cantidades
          </a>
        </span>
        {sDateInfo.comsumptions.map((consumption, i) => {
          let sups = {};
          const matchingSupply = supplies.find(
            (supply) => supply.id === consumption.supplie.id
          );
          if (matchingSupply) sups[i] = matchingSupply;
          const isInvalid =
            matchingSupply && consumption.quantity > matchingSupply.quantity;

          return (
            <div
              className={`flex flex-row items-center w-full ${
                isInvalid && sDateInfo.status == "pending" ? "text-red-500" : ""
              }`}
              key={i}
            >
              {sDateInfo.status === "pending" && (
                <div className="flex items-center justify-center">
                  {!isInvalid ? (
                    <IoMdCheckmark
                      className={`text-accent-green h-[30px] w-[30px]`}
                    />
                  ) : (
                    <MdClear className="text-red-500 h-[30px] w-[30px]" />
                  )}
                </div>
              )}
              {sDateInfo.status === "registered" && (
                <div className="flex items-center justify-center  text-2xl">
                  <LuDot />
                </div>
              )}
              <div className="w-full p-2 py-1">
                <span className="font-poppins text-average-gray">
                  {consumption.supplie.sName}
                </span>
              </div>
              <div>
                <span className="whitespace-nowrap font-poppins font-bold">
                  {consumption.quantity}
                </span>
              </div>
              {sDateInfo.status === "pending" && (
                <span className="font-poppins">/</span>
              )}
              {sDateInfo.status === "pending" && (
                <div>
                  <span className="whitespace-nowrap font-poppins font-bold">
                    {sups[i].quantity}
                  </span>
                </div>
              )}
              <span className="font-poppins text-average-gray pl-1">
                {suppliesUnits[sups[i].unit]}
              </span>
            </div>
          );
        })}
      </div>
      <div
        className="flex flex-col items-center"
        onMouseEnter={() => setShowHover(true)}
        onMouseLeave={() => setShowHover(false)}
      >
        {!validDate && showHover && (
          <PopUp
            title={"Fecha no disponible"}
            message={
              "Mientras la fecha se habilita, puedes probar con otro Bloque."
            }
            type={"alert"}
            customPosL={"md:left-0 left-[-120px]"}
          />
        )}
        <button
          className={` w-fit bg-dark-green text-xl  rounded-full py-4 px-8 text-white  font-bold font-poppins ${
            validDate &&
            sDateInfo.status === "pending" &&
            !hasInvalidConsumption &&
            !updating
              ? "hover:bg-accent-green transition-all duration-100"
              : "bg-default-gray cursor-not-allowed"
          }`}
          onClick={() => {
            if (pos === 0) handleClickRegister();
          }}
          disabled={
            !validDate ||
            sDateInfo.status === "registered" ||
            updating ||
            hasInvalidConsumption
          }
        >
          {validDate && sDateInfo.status === "pending"
            ? "Registrar"
            : sDateInfo.status === "registered"
            ? "Registrado"
            : "Deshabilitado"}
        </button>
        <span className="font-poppins text-average-gray text-xs mt-2">
          {pos == 0
            ? sDateInfo.status === "pending"
              ? "*Esta acción solo se puede realizar una vez*"
              : `*Registrado el ${new Date(
                  sDateInfo.updatedAt
                ).toLocaleString()}*`
            : ""}
        </span>
      </div>
    </div>
  );
};

export default Card;
